<template>
  <div>
    <el-dialog
      id="editDialog"
      :title="orderId ? '修改采购退货单' : '新增采购退货单'"
      :visible="true"
      @close="close(false)"
      width="1000px"
    >
      <el-form
        :model="headInfo"
        label-position="right"
        label-width="100px"
        ref="editOrderFormRef"
        :rules="getRules"
        v-if="headInfo"
      >
        <el-form-item label="单号" v-if="headInfo.id">
          <span v-fmtype="headInfo.orderNo ? null : 'info'">{{
            headInfo.orderNo || "草稿"
          }}</span>
          <el-tag
            class="fm-ml-5"
            :type="
              $jsTool.getOrderApprovalStatusType(
                headInfo.orderApprovalStatusEnum
              )
            "
            >{{ headInfo.orderApprovalStatusEnum.Desc }}</el-tag
          >
        </el-form-item>
        <el-form-item label="单据日期" prop="orderDate">
          <el-date-picker
            v-model="headInfo.orderDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择单据日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="供应商" prop="supplierId">
          <SupplierSelect
            :value="supplier"
            @select="selectSupplier"
          ></SupplierSelect>
        </el-form-item>

        <el-form-item label="采购单" prop="relatedPurchaseOrderHeadId">
          <el-input
            :value="getSelectLabel('PurchaseOrder')"
            placeholder="请选择需要退货的采购单"
            style="width: 400px"
            readonly
            suffix-icon="el-icon-arrow-right"
            @click.native="toSelectPurchaseOrderPage"
          ></el-input>
        </el-form-item>

        <el-form-item label="所选商品" prop="totalQuantity">
          <div class="fm-flex">
            <p
              v-fmtype="'success'"
              v-if="headInfo.totalQuantity && headInfo.totalQuantity > 0"
            >
              {{ "共 " + headInfo.totalQuantity + " 件商品" }}
            </p>
            <span v-fmtype="'error'" v-else>未选择商品</span>
            <span>，总采购价：</span>
            <FmAmount :amount="headInfo.commodityRetailTotalAmount"></FmAmount>
            <el-button
              class="fm-ml-15"
              type="primary"
              plain
              size="mini"
              icon="el-icon-plus"
              @click="toSelectPurchaseOrderItemPage"
              >选择商品</el-button
            >
          </div>
        </el-form-item>

        <el-table
          :data="itemList || []"
          stripe
          :row-key="
            (row) => {
              return row.itemNo;
            }
          "
          max-height="500px"
          style="width: 100%"
        >
          <el-table-column
            label="商品图片"
            width="100"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityImage
                :commodity="
                  scope.row.relatedPurchaseOrderItem.commoditySnapshot
                "
                :commoditySpec="
                  scope.row.relatedPurchaseOrderItem.commoditySpecSnapshot
                "
              ></CommodityImage>
            </template>
          </el-table-column>
          <el-table-column
            prop="commoditySnapshot.name"
            label="商品信息"
            min-width="150"
            align="left"
            header-align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div style="line-height: 1.3em">
                <span style="font-size: 1.1em">{{
                  scope.row.relatedPurchaseOrderItem.commoditySnapshot.name
                }}</span
                ><br />
                {{
                  "规格：" +
                  scope.row.relatedPurchaseOrderItem.commoditySpecSnapshot
                    .specName
                }}<br />
                {{
                  "分类：" +
                  scope.row.relatedPurchaseOrderItem.commoditySnapshot
                    .commodityCategory.name
                }}<br />
                {{
                  "颜色：" +
                  scope.row.relatedPurchaseOrderItem.commoditySnapshot.color
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="relatedPurchaseOrderItem.retailPrice"
            label="商品采购价"
            width="120"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount
                :amount="scope.row.relatedPurchaseOrderItem.retailPrice"
              ></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemQuantity"
            label="退货数量"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityQuantityInputBox
                :key="
                  'itemQuantityInputNumber' + scope.$index + itemQuantityKey
                "
                :value="scope.row.itemQuantity"
                size="small"
                :max="scope.row.relatedPurchaseOrderItem.itemQuantity"
                @change="
                  (e) => {
                    changeItemQuantity(scope.$index, scope.row, e);
                  }
                "
              ></CommodityQuantityInputBox>
            </template>
          </el-table-column>
          <el-table-column
            prop="unit"
            label="单位"
            width="100"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.relatedPurchaseOrderItem.commoditySnapshot.unit }}
            </template>
          </el-table-column>
          <el-table-column
            prop="commodityRetailTotalAmount"
            label="总采购价"
            width="120"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount
                :amount="scope.row.commodityRetailTotalAmount"
              ></FmAmount>
            </template>
          </el-table-column>
        </el-table>

        <el-form-item label="入库标识" class="fm-mt-10" prop="warehousedMark">
          <el-tooltip
            slot="label"
            effect="dark"
            content=""
            placement="top-start"
          >
            <div slot="content" style="line-height: 1.5em">
              <div style="font-weight: bold">入库标识说明</div>
              入库标识所选商品是否已经入库，选项会影响后续单据流程。<br />
              若已入库则会影响所选商品的已入库数量，后续需要创建出库单将已入库商品退回；<br />
              未入库则会影响所选商品的待入库数量，后续无需为商品进行出库操作，自动扣减待出库数量。
            </div>
            <div>
              <i class="el-icon el-icon-question fm-mr-5"></i>
              <span>入库标识</span>
            </div>
          </el-tooltip>
          <div class="fm-flex">
            <el-switch
              v-model="headInfo.warehousedMark"
              :active-color="$jsTool.getColor('success')"
              :inactive-color="$jsTool.getColor('warning')"
            >
            </el-switch>
            <p
              v-fmtype="'success'"
              class="fm-ml-10"
              v-if="headInfo.warehousedMark"
            >
              已入库
            </p>
            <span v-fmtype="'warning'" class="fm-ml-10" v-else>未入库</span>
          </div>
        </el-form-item>

        <el-form-item label="付款标识" class="fm-mt-10" prop="paidMark">
          <el-tooltip
            slot="label"
            effect="dark"
            content=""
            placement="top-start"
          >
            <div slot="content" style="line-height: 1.5em">
              <div style="font-weight: bold">付款标识说明</div>
              发付款标识所选商品是否已经付款，选项会影响后续单据流程。<br />
              若已付款则会影响所选商品的已付款金额，后续需要创建收款单将已付款的商品收款；<br />
              未付款则会影响所选商品的待付款金额，后续无需为商品进行收款操作，自动扣减待付款金额。
            </div>
            <div>
              <i class="el-icon el-icon-question fm-mr-5"></i>
              <span>付款标识</span>
            </div>
          </el-tooltip>
          <div class="fm-flex">
            <el-switch
              v-model="headInfo.paidMark"
              :active-color="$jsTool.getColor('success')"
              :inactive-color="$jsTool.getColor('warning')"
            >
            </el-switch>
            <p v-fmtype="'success'" class="fm-ml-10" v-if="headInfo.paidMark">
              已付款
            </p>
            <span v-fmtype="'warning'" class="fm-ml-10" v-else>未付款</span>
          </div>
        </el-form-item>

        <el-form-item label="退款金额" prop="orderAmount">
          <el-input-number
            v-model="headInfo.orderAmount"
            size="small"
            :precision="2"
            :min="0"
            :max="
              typeof headInfo.commodityRetailTotalAmount == 'string'
                ? Number(headInfo.commodityRetailTotalAmount)
                : headInfo.commodityRetailTotalAmount
            "
            :step="1"
            style="width: 180px"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="业务员" prop="saleUserIdList">
          <UserTransfer
            v-model="headInfo.saleUserIdList"
            :userList="saleUserList"
            @addUser="addSaleUser"
            @cancelUser="cancelSaleUser"
          ></UserTransfer>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            v-model="headInfo.remark"
            style="width: 400px"
            placeholder="请输入备注信息"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close(false)">取 消</el-button>
        <el-button type="primary" @click="edit(false)"> 保存至草稿 </el-button>
        <el-popconfirm
          icon="el-icon-info"
          :icon-color="$jsTool.getColor('warning')"
          :title="
            orderConfig.needApproval
              ? '是否将单据提交审批？'
              : '当前单据提交后将自动审批通过，请确认单据信息无误，是否继续提交？'
          "
          @confirm="edit(true)"
        >
          <el-button slot="reference" type="success" @click.native.stop>
            保存并提交
          </el-button>
        </el-popconfirm>
      </div>
    </el-dialog>

    <PurchaseOrderSelectDialog
      :show="purchaseOrderSelectDialogShow"
      :supplierId="supplier.id"
      from="PurchaseReturnOrder"
      :selectList="itemList"
      @close="purchaseOrderSelectDialogShow = false"
      @selectPurchaseOrder="selectPurchaseOrder"
      v-if="purchaseOrderSelectDialogShow"
    >
    </PurchaseOrderSelectDialog>

    <PurchaseOrderItemSelectDialog
      :show="purchaseOrderItemSelectDialogShow"
      from="PurchaseReturnOrder"
      :supplierId="supplier.id"
      :purchaseOrderId="relatedPurchaseOrderHead.id"
      :selectList="itemList"
      @close="purchaseOrderItemSelectDialogShow = false"
      @selectPurchaseOrderItem="selectPurchaseOrderItem"
      v-if="purchaseOrderItemSelectDialogShow"
    >
    </PurchaseOrderItemSelectDialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebPurchaseReturnOrderEditDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: null,
    },
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          Object.assign(this.$data, this.$options.data());
          this.$nextTick(() => {
            this.$refs.editOrderFormRef.clearValidate();
          });
          this.initOrderData();
          this.getOrderConfig();
          this.quantityMinLimit = this.$jsTool.getTenantDecimalLength();
          if (this.orderId) {
            setTimeout(async () => {
              await this.getOrderInfo();
              this.$nextTick(() => {
                this.$refs.editOrderFormRef.clearValidate();
              });
            }, 100);
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    getRules() {
      let res = {
        orderDate: this.$ruleUtil.simple({
          fieldName: "单据日期",
          handleType: "选择",
          required: true,
        }),
        supplierId: this.$ruleUtil.simple({
          fieldName: "供应商",
          handleType: "选择",
          required: true,
        }),
        relatedPurchaseOrderHeadId: this.$ruleUtil.simple({
          fieldName: "退货采购单",
          handleType: "选择",
          required: true,
        }),
        saleUserIdList: this.$ruleUtil.array("业务员", "选择", 1),
        totalQuantity: this.$ruleUtil.quantity(
          "退货商品",
          this.quantityMinLimit,
          1000
        ),
      };
      return res;
    },
  },
  data() {
    return {
      orderConfig: {
        needApproval: true,
        selectSaleUser: false,
      },

      // 预选的单据信息
      preInfo: {
        purchaseOrderId: null,
        purchaseOrder: {},
      },

      orderDatePickerShow: false,
      editItemPopupShow: false,
      editItem: {},

      id: null,
      headInfo: {
        orderApprovalStatusEnum: {},
        orderDate: null,
        supplierId: null,
        relatedPurchaseOrderHeadId: null,
        warehousedMark: true,
        paidMark: true,
        saleUserIdList: [],
        commodityRetailTotalAmount: "0.00",
        orderAmount: "0.00",
        totalQuantity: 0,
        orderParam: "",
        remark: "",
      },
      itemList: [],
      supplier: {},
      saleUserList: [],
      relatedPurchaseOrderHead: {},

      purchaseOrderSelectDialogShow: false,
      purchaseOrderItemSelectDialogShow: false,
      itemQuantityKey: "null",

      quantityMinLimit: 0.001,
    };
  },
  methods: {
    // 业务员
    addSaleUser(list) {
      this.saleUserList = this.saleUserList.concat(list);
    },
    cancelSaleUser(list) {
      let cancelIdList = list.map((d) => d.id);
      this.saleUserList = this.saleUserList.filter(
        (d) => !cancelIdList.some((f) => f == d.id)
      );
    },
    async handlePreInfo() {
      if (this.preInfo.purchaseOrderId) {
        let getOrderRes = await this.$api.purchaseOrder_findVoById(
          this.preInfo.purchaseOrderId
        );
        if (getOrderRes && getOrderRes.success) {
          let purchaseOrderVo = getOrderRes.data;
          this.preInfo.purchaseOrder = purchaseOrderVo;
          this.headInfo = {
            ...this.headInfo,
            supplierId: purchaseOrderVo.head.supplierId,
            relatedPurchaseOrderHeadId: purchaseOrderVo.head.id,
            saleUserIdList: purchaseOrderVo.head.saleUserList.map(
              (d) => d.userId
            ),
          };
          this.supplier = purchaseOrderVo.head.supplier;
          this.relatedPurchaseOrderHead = purchaseOrderVo.head;
          this.saleUserList = purchaseOrderVo.head.saleUserList.map(
            (d) => d.user
          );
          this.$message.success("已初始化部分单据信息，请继续完善其他信息");
        } else {
          this.$showModal({
            title: "操作提醒",
            content: "获取销售退货单信息失败",
            confirmText: "返回",
            showCancel: false,
            allowBackPress: false,
            success(res) {
              uni.navigateBack();
            },
          });
          return;
        }
      }
    },
    showWarehousedTips() {
      this.$jsTool.showTipsModal(
        "入库标识说明",
        "入库标识所选商品是否已经入库，选项会影响后续单据流程。\n" +
          "若已入库则会影响所选商品的已入库数量，后续需要创建出库单将已入库商品退回；\n" +
          "未入库则会影响所选商品的待入库数量，后续无需为商品进行出库操作，自动扣减待出库数量。"
      );
    },
    showPaidTips() {
      this.$jsTool.showTipsModal(
        "付款标识说明",
        "发付款标识所选商品是否已经付款，选项会影响后续单据流程。\n" +
          "若已付款则会影响所选商品的已付款金额，后续需要创建收款单将已付款的商品收款；\n" +
          "未付款则会影响所选商品的待付款金额，后续无需为商品进行收款操作，自动扣减待付款金额。"
      );
    },
    async initOrderData() {
      let userInfo = await this.$storageUtil.getUserInfo();
      this.headInfo.orderDate = this.$moment(new Date()).format("yyyy-MM-DD");
      this.headInfo.saleUserIdList = [userInfo.id];
      this.saleUserList = [userInfo];
    },
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:PurchaseReturnOrder:NeedApproval",
        "Order:PurchaseReturnOrder:SelectSaleUser",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:PurchaseReturnOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.orderConfig.needApproval = false;
        }

        let selectSaleUserIndex = res.data.findIndex(
          (d) => d.code == "Order:PurchaseReturnOrder:SelectSaleUser"
        );
        if (
          selectSaleUserIndex > -1 &&
          res.data[selectSaleUserIndex].value == "true"
        ) {
          this.orderConfig.selectSaleUser = true;
        }
      }
    },
    // 编辑item
    editItemClick(item) {
      this.editItemPopupShow = true;
      this.editItem = JSON.parse(JSON.stringify(item));
    },
    changeItemQuantity(index, row, value) {
      let that = this;
      if (value <= 0) {
        this.$confirm("是否移除所选商品?", "操作提醒", {
          confirmButtonText: "移除",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            that.itemList.splice(index, 1);
            that.selectPurchaseOrderItem(that.itemList || []);
          })
          .catch(() => {
            row.itemQuantity = that.quantityMinLimit;
            // this.changeItemQuantity(index, row, 1);
            this.itemQuantityKey = Math.random();
          });
      } else {
        let itemAmount = that.$jsTool.multi(
          row.relatedPurchaseOrderItem.retailPrice,
          value
        );
        row = {
          ...row,
          itemQuantity: value,
          commodityRetailTotalAmount: itemAmount,
        };
        let item = {
          ...that.itemList[index],
          itemQuantity: row.itemQuantity,
          commodityRetailTotalAmount: itemAmount,
        };
        that.itemList.splice(index, 1, item);
        that.selectPurchaseOrderItem(that.itemList);
      }
    },

    // 获取已选择的文本
    getSelectLabel(type) {
      if (type == "SaleUser") {
        if (this.saleUserList && this.saleUserList.length > 0) {
          return this.saleUserList
            .map((item) => {
              return item.name;
            })
            .join("、");
        }
      } else if (type == "Supplier") {
        if (this.supplier && this.supplier.name) {
          return this.supplier.name;
        }
      } else if (type == "PurchaseOrder") {
        if (this.relatedPurchaseOrderHead) {
          return this.relatedPurchaseOrderHead.orderNo;
        }
      }
      return null;
    },

    // 选择供应商
    selectSupplier(item) {
      this.headInfo.supplierId = item.id;
      this.supplier = item;
      // 清空已选单据
      this.headInfo.relatedPurchaseOrderHeadId = null;
      this.relatedPurchaseOrderHead = {};
      // 清空已选商品
      this.itemList = [];
      this.selectPurchaseOrderItem([]);
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("supplierId");
      });
      setTimeout(() => {
        this.toSelectPurchaseOrderPage();
      }, 1000);
    },

    // 选择采购单
    toSelectPurchaseOrderPage() {
      if (this.preInfo.purchaseOrderId) {
        this.$message.error("自动创建采购退货单时无法重新选择采购单");
        return;
      }
      let that = this;
      if (!this.supplier || !this.supplier.id) {
        this.$message.error("请先选择供应商");
        return;
      }
      this.purchaseOrderSelectDialogShow = true;
    },
    selectPurchaseOrder(item) {
      this.headInfo.relatedPurchaseOrderHeadId = item.id;
      this.relatedPurchaseOrderHead = item;
      // 清空已选商品
      this.itemList = [];
      this.selectPurchaseOrderItem([]);
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("relatedPurchaseOrderHeadId");
      });
      setTimeout(() => {
        this.toSelectPurchaseOrderItemPage();
      }, 1000);
    },

    // 选择采购单行项目
    toSelectPurchaseOrderItemPage() {
      let that = this;
      if (!this.supplier || !this.supplier.id) {
        this.$message.error("请先选择供应商");
        return;
      }
      if (!this.relatedPurchaseOrderHead || !this.relatedPurchaseOrderHead.id) {
        this.$message.error("请先选择采购单");
        return;
      }
      this.purchaseOrderSelectDialogShow = false;
      this.purchaseOrderItemSelectDialogShow = true;
    },
    selectPurchaseOrderItem(list) {
      this.itemList = list;
      this.headInfo.commodityRetailTotalAmount = this.$jsTool.sum(
        list.map((d) => d.commodityRetailTotalAmount)
      );
      this.headInfo.orderAmount = this.headInfo.commodityRetailTotalAmount;
      this.headInfo.totalQuantity = Number(
        this.$jsTool.sumQuantity(list.map((d) => d.itemQuantity))
      );
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("totalQuantity");
      });
    },

    // 选择业务员
    toSelectSaleUserPage() {
      if (!this.orderConfig.selectSaleUser) {
        this.$message.error(
          "无法重新选择业务员（选择采购单后将自动使用采购单的业务员）"
        );
        return;
      }
      let that = this;
      uni.navigateTo({
        url: "/pages/my/user/select?multiSelect=true",
        success(res) {
          // 通过eventChannel向被打开页面传送数据
          res.eventChannel.emit("userList", {
            userList: that.saleUserList,
          });
        },
      });
    },
    selectUser(userList = []) {
      this.saleUserList = userList;
      this.headInfo.saleUserIdList = userList.map((item) => item.id);
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("saleUserIdList");
      });
    },

    // 单据日期
    confirmPicker(e, type) {
      if (type == "OrderDate") {
        this.headInfo.orderDate = e.value;
        this.$nextTick(() => {
          this.$refs.editOrderFormRef.validateField("orderDate");
        });
      }
      this.closePicker(type);
    },
    closePicker(type) {
      if (type == "OrderDate") {
        this.orderDatePickerShow = false;
      }
    },

    async getOrderInfo(args) {
      let res = await this.$api.purchaseReturnOrder_findVoById(this.orderId, {
        showLoading: true,
        loadingParam: {
          target: "#editDialog > *",
          lock: true,
        },
        ...args,
      });
      if (res && res.success) {
        this.headInfo = {
          ...res.data.head,
          saleUserIdList: res.data.head.saleUserList.map((d) => d.userId),
        };
        this.itemList = res.data.itemList;
        this.supplier = res.data.head.supplier;
        this.saleUserList = res.data.head.saleUserList.map((d) => d.user);
        this.relatedPurchaseOrderHead = res.data.head.relatedPurchaseOrderHead;
        if (this.headInfo.orderParam) {
          let orderParam = JSON.parse(this.headInfo.orderParam);
          this.preInfo.purchaseOrderId = orderParam.preInfo.purchaseOrderId;
        }
      }
    },
    edit(submit) {
      this.$refs.editOrderFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.headInfo.id
          ? submit
            ? await this.$api.purchaseReturnOrder_updateAndSubmit(
                {
                  headUpdatePojo: this.headInfo,
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
            : await this.$api.purchaseReturnOrder_update(
                {
                  headUpdatePojo: this.headInfo,
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
          : submit
          ? await this.$api.purchaseReturnOrder_saveIntoDraftAndSubmit(
              {
                headAddNewPojo: this.headInfo,
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            )
          : await this.$api.purchaseReturnOrder_saveIntoDraft(
              {
                headAddNewPojo: this.headInfo,
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            );
        if (requestRes && requestRes.success) {
          this.close(true);
        }
      });
    },
    close(flush) {
      this.$emit("close", flush);
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/PurchaseReturnOrderEditDialog.vue